module.exports = __webpack_public_path__ + "static/img/head-icon.d572e65.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/head-icon.png
// module id = l5z6
// module chunks = 1